import { Section, EyebrowHeading } from "../Section";
import type { Audience } from "@/content/audiences";

export function AudienceProcessSteps({ audience: a }: { audience: Audience }) {
  return (
    <Section className="pt-0">
      <EyebrowHeading
        eyebrow="Så jobbar vi med er"
        title="Tre steg från första samtalet till löpande leverans."
      />
      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {a.processSteps.map((s) => (
          <article
            key={s.title}
            className="rounded-3xl border border-white/10 bg-surface p-7"
          >
            <h3 className="text-lg font-semibold text-mint">{s.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground/85">
              {s.body}
            </p>
          </article>
        ))}
      </div>
    </Section>
  );
}
